class StorageService {
  getItem(key) {
    const result = localStorage.getItem(key);
    return result;
  }

  setItem(key, value) {
    localStorage.setItem(key, value);
  }

  clear() {
    localStorage.clear();
  }

  removeItem(key) {
    localStorage.removeItem(key)
  }
}

export default new StorageService();
